<template>
    <div class="container">
        <div class="container">
            <div class="top">
                <div class="title">设置兑换密码</div>
                <div style="width: 100%; font-size: 16px; color: #666; margin-top: 2vw; text-align: center;">请输入密码</div>

                <div @click="back" style="width: 16vw; height: 16vw; position: absolute; display: flex; align-items: center; top: 2vw; left: 2vw">
                    <img style="width: 10vw; height: 7.93vw;" src="../assets/back.png" />
                </div>

                <input class="input_p" placeholder="6位数字密码" maxlength="6" type="password" v-model="password" />

                <div @click="btnConfirm" class="btn_next">下一步</div>
            </div>
         
        </div>

    </div>
</template>


<script>
import axios from 'axios';
import { prefix, userWithdrawList, userFinance } from '../url';

export default ({
    data() {
        return {
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            password: '',
            user_score: 0.00
        };
    },

    created() {
        // this.formatUrlParams();
    },

    methods: {
        back() {
            window.location.href = '/profit-account';
        },

        btnConfirm() {
            if (this.password.length != 6) {
                alert('请输入6位数字密码！')
                return;
            }

            localStorage.setItem("PASSWORD_SET", this.password);
            window.location.href = '/profit-password-second';
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
}

.top {
    width: 100vw;
    height: 74.6vw;
    display: flex;
    flex-direction: column;
}
.title {
    margin-top: 20vw;
    width: 100%;
    text-align: center;
    font-size: 19px;
    font-weight: 500;
}

.input_p {
    width: 60vw;
    height: 12vw;
    margin-top: 10vw;
    margin-left: 20vw;
    border: 1px #EEE solid;
    border-radius: 12px;
    text-align: center;
    font-size: 24px;
}
.btn_next {
    display: flex;
    width: 88vw;
    height: 12vw;
    background: linear-gradient(to right, #CBACFF, #7384FF);
    align-self: center;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: white;
    border-radius: 28px;
    margin-top: 10vw;
}
</style>